import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import OrderFormCard from "../components/OrderFormCard";
import ProductCard from "../components/ProductCard";
import ProductGallery from "../components/ProductGallery";
import { fetchShopProduct, fetchShopProducts } from "../api";
import { formatPrice } from "../utils";
import {
  STORE_CATALOG_PATH,
  STORE_HOME_PATH,
} from "../../routes";


export default function ProductDetailPage() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    async function loadProduct() {
      setLoading(true);
      setError("");

      try {
        const productData = await fetchShopProduct(slug);
        if (!active) {
          return;
        }

        setProduct(productData);

        const relatedData = await fetchShopProducts({
          category: productData.category?.slug,
          limit: 4,
        });

        if (!active) {
          return;
        }

        setRelatedProducts(relatedData.filter((item) => item.slug !== productData.slug).slice(0, 3));
      } catch (requestError) {
        if (active) {
          setError("Mahsulot tafsilotlarini yuklashda xatolik yuz berdi.");
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadProduct();

    return () => {
      active = false;
    };
  }, [slug]);

  if (loading) {
    return (
      <main className="store-page">
        <div className="store-empty">Mahsulot yuklanmoqda...</div>
      </main>
    );
  }

  if (error || !product) {
    return (
      <main className="store-page">
        <div className="store-empty">{error || "Mahsulot topilmadi."}</div>
      </main>
    );
  }

  return (
    <main className="store-page">
      <nav className="store-breadcrumbs store-reveal">
        <Link to={STORE_HOME_PATH}>Bozor</Link>
        <span>/</span>
        <Link to={STORE_CATALOG_PATH}>Catalog</Link>
        <span>/</span>
        <Link to={`${STORE_CATALOG_PATH}?category=${product.category?.slug}`}>{product.category?.name}</Link>
        <span>/</span>
        <strong>{product.name}</strong>
      </nav>

      <section className="store-detail-layout store-reveal">
        <div className="store-detail-main">
          <ProductGallery product={product} />

          <article className="store-detail-copy">
            <h1 className="store-display store-detail-title">{product.name}</h1>
            <p className="store-detail-summary">
              {product.short_description || "Premium gadjet va aksessuarlar uchun ishlab chiqilgan storefront detail view."}
            </p>

            <div className="store-detail-price-row">
              <strong>{formatPrice(product.price)}</strong>
              {product.compare_at_price ? <span>{formatPrice(product.compare_at_price)}</span> : null}
            </div>

            <div className="store-detail-panels">
              <div className="store-detail-panel">
                <span>Category</span>
                <strong>{product.category?.name}</strong>
              </div>
              <div className="store-detail-panel">
                <span>Muallif</span>
                <strong>{product.brand?.name}</strong>
              </div>
            </div>

            <div className="store-rich-copy">
              <h2>Mahsulot tavsifi</h2>
              <p>{product.description || "Tavsif hali kiritilmagan."}</p>
            </div>
          </article>
        </div>

        <OrderFormCard product={product} />
      </section>

      <section className="store-section store-reveal">
        <div className="store-section-head">
          <div>
            <p className="store-section-kicker">Related Products</p>
            <h2>Shu kategoriya ichidagi boshqa mahsulotlar.</h2>
          </div>
        </div>

        {relatedProducts.length ? (
          <div className="store-product-grid">
            {relatedProducts.map((item, index) => (
              <ProductCard key={item.id} index={index} product={item} />
            ))}
          </div>
        ) : (
          <div className="store-empty">Qo'shimcha related mahsulot topilmadi.</div>
        )}
      </section>
    </main>
  );
}
